import "./style.scss";
import { LifecycleOnLoad } from "./lifeclycle/onload";
import { LifecycleAfterViewInit } from "./lifeclycle/afterinit";

(() => {
  new LifecycleOnLoad();
  new LifecycleAfterViewInit();
})();
